/**
 * @generated SignedSource<<1edb4c5dc3278b11f4c59c933d8e8702>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type timelinesInSuperSplashLiveQuery$variables = {
  entityUuid: string;
};
export type timelinesInSuperSplashLiveQuery$data = {
  readonly liveArticle: {
    readonly liveContents: ReadonlyArray<{
      readonly entityId: string;
      readonly publishedDate: number | null | undefined;
      readonly title: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type timelinesInSuperSplashLiveQuery = {
  response: timelinesInSuperSplashLiveQuery$data;
  variables: timelinesInSuperSplashLiveQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "entityUuid"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "entityUuid",
        "variableName": "entityUuid"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "LiveContent",
  "kind": "LinkedField",
  "name": "liveContents",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publishedDate",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "timelinesInSuperSplashLiveQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LiveArticle",
        "kind": "LinkedField",
        "name": "liveArticle",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "timelinesInSuperSplashLiveQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LiveArticle",
        "kind": "LinkedField",
        "name": "liveArticle",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6ba29d7b938e50b218bc31f2a53586ec",
    "id": null,
    "metadata": {},
    "name": "timelinesInSuperSplashLiveQuery",
    "operationKind": "query",
    "text": "query timelinesInSuperSplashLiveQuery(\n  $entityUuid: String!\n) {\n  liveArticle(filter: {entityUuid: $entityUuid}) {\n    liveContents {\n      entityId\n      title\n      publishedDate\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "afc1f847881bdadb8d3e42f057124527";

export default node;
